import {
    type FieldNameProps,
    pickFieldNameProps,
} from "@design-system/Field/Field";
import type {
    KitFieldChromeBaseProps,
    KitFieldChromeProps,
} from "./kitFieldProps.types";

/** Every base chrome key made required, so a new one must be forwarded here. */
type ForwardedChromeBaseProps = {
    [
        Key in keyof Required<KitFieldChromeBaseProps>
    ]: KitFieldChromeBaseProps[Key];
};

/**
 * Picks the `Field` chrome a kit field hands to `FormikField`, keeping the
 * `label` / `aria-labelledby` union intact, which a rest spread over a
 * generic props type would collapse.
 */
export const pickChromeProps = (
    props: KitFieldChromeProps,
): ForwardedChromeBaseProps & FieldNameProps => {
    const { optional, description, className, showErrorMessage } = props;
    const baseProps: ForwardedChromeBaseProps = {
        optional,
        description,
        className,
        showErrorMessage,
    };
    return { ...baseProps, ...pickFieldNameProps(props) };
};
